import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { SummaryTitle, SummaryContainer } from '../css';
import { AdditionalServiceItem, AdditionalServiceLabel, AdditionalServicesTable } from './css';

const AdditionalServices = ({ data }) => (
  <SummaryContainer>
    <SummaryTitle>{t('AdditionalServices')}</SummaryTitle>
    <AdditionalServicesTable>
      {data.map((serviceLabel, index) => (
        <AdditionalServiceItem key={index}>
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
                            // eslint-disable-next-line max-len
              d="M14.6075 2.63191C15 2.88414 15.1179 3.41335 14.8707 3.81394L7.52857 14.0996C7.38616 14.3304 7.14461 14.4782 6.87802 14.4978C6.61143 14.5174 6.35162 14.4063 6.1783 14.1987L1.20057 8.23601C0.899737 7.87565 0.94215 7.33467 1.2953 7.0277C1.64845 6.72073 2.17861 6.764 2.47945 7.12436L6.71595 12.1991L13.4491 2.90055C13.6962 2.49996 14.2149 2.37969 14.6075 2.63191Z"
              fill="#E55916"
            />
          </svg>
          <AdditionalServiceLabel>
            {serviceLabel}
          </AdditionalServiceLabel>
        </AdditionalServiceItem>
      ))}
    </AdditionalServicesTable>
  </SummaryContainer>
);

AdditionalServices.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
};

export default AdditionalServices;
